import { createSelector } from 'reselect';
export var getPortalData = function (state) { return state.portalData; };
export var getUiState = function (state) { return state.ui; };
export var getSelectedTeamAccount = createSelector(getUiState, function (ui) { return ui.selectedTeamAccount; });
export var getAllTeamAccounts = createSelector(getPortalData, function (portalData) {
    var teamAccounts = portalData.teamAccounts || [];
    return teamAccounts;
});
export var getSelectedTeamAccountContent = createSelector(getAllTeamAccounts, getSelectedTeamAccount, function (allTeamAccounts, selectedTeamAccountId) {
    return allTeamAccounts.find(function (value) { return value.id === selectedTeamAccountId; });
});
export var getAllTeamAccountRoles = createSelector(getPortalData, function (portalData) {
    var teamAccountRoles = portalData.teamAccountRoles || [];
    return teamAccountRoles;
});
export var getAllTeamAccountRolesAsAdmin = createSelector(getAllTeamAccountRoles, function (allTeamAccRoles) {
    return (allTeamAccRoles || []).filter(function (teamAccountRole) { return teamAccountRole.role === 'ADMIN'; });
});
export var shouldRenderMultiPortalSelector = createSelector(getAllTeamAccountRolesAsAdmin, function (allTeamAccountRolesAsAdmin) {
    var moreThanOneTeamAccountRolesAsAdmin = allTeamAccountRolesAsAdmin.length > 1;
    return moreThanOneTeamAccountRolesAsAdmin;
});
export var getMultiPortalSelectorOptions = createSelector(shouldRenderMultiPortalSelector, getAllTeamAccounts, getAllTeamAccountRolesAsAdmin, function (shouldRender, allTeamAccounts, adminsToTeamAccountRoles) {
    if (!shouldRender) {
        return [];
    }
    var teamAccountKeyValuesPairs = allTeamAccounts.map(function (teamAccount) {
        return [teamAccount.id, teamAccount.name];
    });
    var teamAccountMap = new Map(teamAccountKeyValuesPairs);
    var result = [];
    adminsToTeamAccountRoles.forEach(function (teamAccountRoles) {
        var teamAccountId = teamAccountRoles.teamAccountId;
        var teamAccountName = teamAccountMap.get(teamAccountId) || '';
        if (!teamAccountId ||
            !teamAccountName ||
            typeof teamAccountName !== 'string') {
            return;
        }
        result.push({
            name: teamAccountName,
            value: teamAccountId,
        });
    });
    // sort by team account name before returning
    return result.sort(function (teamAccount1, teamAccount2) {
        return teamAccount1.name
            .toLowerCase()
            .localeCompare(teamAccount2.name.toLowerCase());
    });
});
export var getFirstAdminTeamAccount = createSelector(getAllTeamAccountRolesAsAdmin, function (allTeamAccountRolesAsAdmin) {
    if (allTeamAccountRolesAsAdmin.length === 0) {
        return null;
    }
    return allTeamAccountRolesAsAdmin[0];
});
export var getFirstAdminTeamAccountId = createSelector(getFirstAdminTeamAccount, function (firstAdminTeamAccount) {
    if (!firstAdminTeamAccount) {
        return null;
    }
    return firstAdminTeamAccount.teamAccountId;
});
export var getFirstTeamAccountIdFromMultiPortalSelectorOptions = createSelector(shouldRenderMultiPortalSelector, getMultiPortalSelectorOptions, function (shouldRenderMultiPortalSelector, multiPortalSelectorOptions) {
    var fallbackFirstTeamAccountId = null;
    if (!shouldRenderMultiPortalSelector) {
        return fallbackFirstTeamAccountId;
    }
    if (multiPortalSelectorOptions.length === 0) {
        return fallbackFirstTeamAccountId;
    }
    return multiPortalSelectorOptions[0].value || fallbackFirstTeamAccountId;
});
